import type { RevenueAnalyticsRowsPerPage, RevenueAnalyticsSortColumn } from './types';

export type RevenueAnalyticsAction =
    | { type: 'SET_SCOPE'; firmId: string | undefined; superUserMode: boolean }
    | { type: 'SELECT_PROVIDER'; providerId: string }
    | { type: 'SET_PAGE'; page: number }
    | { type: 'SET_ROWS_PER_PAGE'; rowsPerPage: RevenueAnalyticsRowsPerPage }
    | { type: 'TOGGLE_SORT'; column: RevenueAnalyticsSortColumn }
    | { type: 'SET_SYMBOL_SEARCH_INPUT'; value: string }
    | { type: 'APPLY_SYMBOL_SEARCH' }
    | { type: 'CLEAR_SYMBOL_SEARCH' }
    | { type: 'START_CSV_DOWNLOAD' }
    | { type: 'FAIL_CSV_DOWNLOAD' }
    | { type: 'END_CSV_DOWNLOAD' };

export const setScope = (firmId: string | undefined, superUserMode: boolean): RevenueAnalyticsAction => ({
    type: 'SET_SCOPE',
    firmId,
    superUserMode,
});

export const selectProvider = (providerId: string): RevenueAnalyticsAction => ({ type: 'SELECT_PROVIDER', providerId });

export const setPage = (page: number): RevenueAnalyticsAction => ({ type: 'SET_PAGE', page });

export const setRowsPerPage = (rowsPerPage: RevenueAnalyticsRowsPerPage): RevenueAnalyticsAction => ({
    type: 'SET_ROWS_PER_PAGE',
    rowsPerPage,
});

export const toggleSort = (column: RevenueAnalyticsSortColumn): RevenueAnalyticsAction => ({
    type: 'TOGGLE_SORT',
    column,
});

export const setSymbolSearchInput = (value: string): RevenueAnalyticsAction => ({
    type: 'SET_SYMBOL_SEARCH_INPUT',
    value,
});

export const applySymbolSearch = (): RevenueAnalyticsAction => ({ type: 'APPLY_SYMBOL_SEARCH' });

export const clearSymbolSearch = (): RevenueAnalyticsAction => ({ type: 'CLEAR_SYMBOL_SEARCH' });

export const startCsvDownload = (): RevenueAnalyticsAction => ({ type: 'START_CSV_DOWNLOAD' });

export const failCsvDownload = (): RevenueAnalyticsAction => ({ type: 'FAIL_CSV_DOWNLOAD' });

export const endCsvDownload = (): RevenueAnalyticsAction => ({ type: 'END_CSV_DOWNLOAD' });
